import { useEffect, useState } from "react";
import Slider from "react-slick";
import AIEvaluationTable from "./ai-evaluation-table";
import { createAIUsecaseDocumentAPI, getGapAnalysisAPI } from "../../service/ai.service";
import { useAppContext } from "../../context/app.context";
import { getEvaluationPayload, getStorageData } from "../../service/storage.service";
import { useNavigate } from "react-router-dom";
import { Constant, SECTION_NAMES } from "../../helper/constant";
import { DisabledNavLink } from "../../component/sidemenu";

const GapAnalysis = () => {
    const { aiMaturityEval, getAIMaturityEvaluation, updateLoader, calculateUnsignedRevenue } = useAppContext();
    const [gapAnalysis, setGapAnalysis] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate();
    useEffect(() => {
        if (!aiMaturityEval) {
            getAIMaturityEvaluation();
        }
        if (aiMaturityEval) {
            updateLoader(true);
            const maturityEval = getEvaluationPayload(aiMaturityEval);
            getGapAnalysisAPI(maturityEval)
                .then((response) => {
                    setGapAnalysis(response);
                    triggerPDFGeneration(response, maturityEval);
                })
                .catch((error) => console.error("Error fetching gap analysis data:", error))
                .finally(() => updateLoader(false));
        }
        return () => { }
    }, [aiMaturityEval]);

    const triggerPDFGeneration = (gapAnalysis, maturityEval) => {
        const userInfo = getStorageData(Constant.STORAGE_KEYS.USER_INFO);
        const payload = {
            gapAnalysis,
            maturityEval,
            userInfo,
        };
        const data = {
            industryId: userInfo.userInfo.industry,
            revenue: userInfo.userInfo.revenue,
            count: userInfo.userInfo.employee_count,
            inventory: userInfo.userInfo.inventory,
        };
        calculateUnsignedRevenue(data, (aiValue) => {
            payload.aiValue = aiValue;
            createAIUsecaseDocumentAPI(payload).then(r => r)
        });

    }



    const render = () => {
        const sliderConfig = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        }
        return (
            <>
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className=" text-blue h4 mb-3 mb-0">Gap Analysis</h3>
                    <div className="d-flex align-items-center gap-4">
                        <DisabledNavLink to='/ai-maturity-eval'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.AI_MATURITY_EVALUATION}</p></DisabledNavLink>
                        <DisabledNavLink disabled={currentIndex !== 2} to='/ai-value'><p className="m-0 p-0">{SECTION_NAMES.AI_VALUE}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                    </div>
                </div>
                <Slider className="evaluationslider navigatorslider px-5" {...sliderConfig} afterChange={(i) => setCurrentIndex(i)}>
                    <div>
                        <div className="text-center ai-th"><strong>Plotting the Current vs. Target Maturity</strong></div>
                        <div className="d-flex align-items-center justify-content-end gap-1">
                            <div className="Current-Maturity"><span></span> Current Maturity</div>
                            <div className="Target-Maturity ml-4"><span></span> Target Maturity</div>
                        </div>
                        <AIEvaluationTable tableData={aiMaturityEval} timeline freeze />
                    </div>
                    <div>
                        <div className="text-center ai-th"><strong>Identify the current state of AI Maturity</strong></div>
                        <AIEvaluationTable tableData={aiMaturityEval} evaluate />
                    </div>
                    <div>
                        <ul className="gap-list mt-4">
                            {gapAnalysis && gapAnalysis.map((item, index) => <li key={index}>{item.description}</li>)}
                        </ul>
                    </div>
                </Slider>
                {/* <div style={{ textAlign: "center" }}>
                    <button className="slick-arrow slick-prev slick-prev-page" onClick={() => navigate('/ai-maturity-eval')}></button>
                    <button className={`slick-arrow slick-next slick-next-page ${currentIndex === 2 ? '' : 'slick-disabled'}`} disabled={currentIndex !== 2} onClick={() => navigate('/ai-value')}></button>
                </div> */}
            </>
        );
    };
    return render();
}

export default GapAnalysis;